import React, {useContext} from 'react';
import Typography from '@mui/material/Typography';
import BidmiiTextField from '../../../common/StyledComponents/BidmiiTextField';
import {NewProjectContext} from '../utils/NewProjectContext';

interface IProps {
  state?: $TSFixMe;
  setState?: $TSFixMe;
  label: string;
  placeholder: string;
  multiline?: boolean;
  handleKeyDown?: (event: $TSFixMe) => void;
}

const TemplateTextInput = ({
  state,
  setState,
  label,
  placeholder,
  multiline,
  handleKeyDown,
}: IProps) => {
  const {homeDepot} = useContext(NewProjectContext);

  const handleTextInputChange = (event: $TSFixMe) => {
    setState(event.target.value);
  };

  return (
    <>
      <Typography variant="h6" fontSize={22} mb={3} lineHeight={1.4}>
        {label}
      </Typography>
      <BidmiiTextField
        label=""
        autoFocus={window.outerWidth > 500}
        fullWidth
        value={state || ''}
        onChange={handleTextInputChange}
        placeholder={placeholder}
        multiline={multiline}
        rows={multiline ? 4 : undefined}
        onKeyDown={handleKeyDown}
        homeDepot={homeDepot}
      />
    </>
  );
};

export default TemplateTextInput;
